import coronaThumb from "../../../assets/ProjectThumbs/gc-thumb.webp";
import cocktailThumb from "../../../assets/ProjectThumbs/rcr-thumb.webp";
import todoThumb from "../../../assets/ProjectThumbs/todo.webp";

export const projectsData = [
	{
		id: 1,
		thumb: coronaThumb,
		name: "GoCorona Website",
		usefulUrl: "https://www.figma.com/community/file/881195862226597419",
		usefulUrlName: "Figma Design",
		description:
			"This is a simple website built from a Figma mockup by Ganesh Sekhar. It is not pixel perfect since the mockup was available only for 1100px screens. I have used close values and made it responsive.",
		stack: ["HTML", "SCSS", "JavaScript"],
		githubLink: "https://github.com/ForgedCode/GoCorona",
		demoLink: "https://forgedcode.github.io/GoCorona/",
	},
	{
		id: 2,
		thumb: cocktailThumb,
		name: "Random cocktail recipe",
		usefulUrl: "https://www.thecocktaildb.com/api.php",
		usefulUrlName: "CocktailDB API",
		description:
			"The web app was created by using React JS and free Cocktail DB API. It simply gives you a random cocktail recipe as you keep clicking on a button. Check it and probably you will get your favorite cocktail recipe! ",
		stack: ["React JS", "Styled components", "Axios"],
		githubLink: "https://github.com/ForgedCode/cocktail-app",
		demoLink: "https://forgedcode.github.io/cocktail-app/",
	},
	{
		id: 3,
		thumb: todoThumb,
		name: "Todo App",
		usefulUrl: null,
		usefulUrlName: null,
		description:
			"Nothing unusual, another Todo App created by using React JS (React Hooks) from me, another junior developer. :)  ",
		stack: ["React JS", "Styled components", "Local Storage"],
		githubLink: "https://github.com/ForgedCode/as-todo-app",
		demoLink: "https://forgedcode.github.io/as-todo-app/",
	},
];
